// extracted by mini-css-extract-plugin
export default {"sideMenuBtn":"SideMenuBtn_sideMenuBtn__OTmwV","divIcon":"SideMenuBtn_divIcon__Y8ilm","spinner":"SideMenuBtn_spinner__PEmFX","spin":"SideMenuBtn_spin__5iND6"};